// extracted by mini-css-extract-plugin
module.exports = {"PA_ScatterChart":"ScatterChart_PA_ScatterChart__dScNM"};